import { SeamlessConnection, SeamlessCoreStore, Subscription } from '@seamless/store';
import type { Dispatch } from 'redux';
import { initializeStoreConnection } from '../store.util';
import { addFootnote, addFootnotes, removeFootnote, removeFootnotes } from './local-footnotes.reducer';
import {
  Actions,
  ADD_FOOTNOTE,
  ADD_FOOTNOTES,
  connectionName,
  FootnoteActionPayload,
  FootnotesActionPayload,
  FootnoteStoreDispatchers,
  LocalFootnoteStoreState,
  REMOVE_FOOTNOTE,
  REMOVE_FOOTNOTES,
} from './local-footnotes.types';

export const initialState = (): LocalFootnoteStoreState => ({
  contexts: {
    default: [],
  },
});

export class LocalFootnotesConnection extends SeamlessConnection<FootnoteStoreDispatchers, LocalFootnoteStoreState> {
  constructor() {
    super(connectionName);
  }

  get initialState(): LocalFootnoteStoreState {
    return initialState();
  }

  getPublicDispatchers() {
    return {
      addFootnote: (payload: FootnoteActionPayload) => (dispatch: Dispatch) => {
        dispatch(this.getAction(ADD_FOOTNOTE, payload));
      },
      addFootnotes: (payload: FootnotesActionPayload) => (dispatch: Dispatch) => {
        dispatch(this.getAction(ADD_FOOTNOTES, payload));
      },
      removeFootnote: (payload: FootnoteActionPayload) => (dispatch: Dispatch) => {
        dispatch(this.getAction(REMOVE_FOOTNOTE, payload));
      },
      removeFootnotes: (payload: FootnotesActionPayload) => (dispatch: Dispatch) => {
        dispatch(this.getAction(REMOVE_FOOTNOTES, payload));
      },
    };
  }

  getReducer() {
    return (state: LocalFootnoteStoreState, action: Actions): LocalFootnoteStoreState => {
      switch (action.type) {
        case this.getActionType(ADD_FOOTNOTE):
          return addFootnote(state, action.payload as FootnoteActionPayload);
        case this.getActionType(ADD_FOOTNOTES):
          return addFootnotes(state, action.payload as FootnotesActionPayload);
        case this.getActionType(REMOVE_FOOTNOTE):
          return removeFootnote(state, action.payload as FootnoteActionPayload);
        case this.getActionType(REMOVE_FOOTNOTES):
          return removeFootnotes(state, action.payload as FootnotesActionPayload);
        default:
          return state;
      }
    };
  }
}

export let footnotesStore: SeamlessCoreStore;
export let footnoteDispatchers: FootnoteStoreDispatchers;

export const initializeLocalFootnotesStore = async () => {
  footnotesStore = (await initializeStoreConnection<LocalFootnoteStoreState, FootnoteStoreDispatchers>(
    LocalFootnotesConnection,
  )) as SeamlessCoreStore;
  footnoteDispatchers = {
    ...(await footnotesStore.getConnectionDispatchers<FootnoteStoreDispatchers>(connectionName)),
  };
};

export const getState = (): Promise<LocalFootnoteStoreState> =>
  new Promise((resolve) => footnotesStore.once(connectionName, resolve));
